import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tooltip, Tr } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import AddButton from 'components/AddButton';
import { PropertyValue } from 'models/response/propertyValue.interface';
import { addDimesionItem, fetchPropertyValue, getPropertyValues } from 'redux/DimensionPageSlice';
import { getSelectedDriver } from 'redux/PlanPageSlice';
import { getBaseScenario } from 'redux/ScenarioSlice';
import addNewDimensionItem from 'utils/AddNewDimItem';
import PlanPermission from 'container/PlanPermission';
import { AppDispatch } from 'utils/GlobalHelpers';
import {
  PLAN_TABLE_CELL_BORDER,
  PLAN_TABLE_HEADER_BG,
  PLAN_TEXT,
  neutral,
  text as textToken,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';

import PropertyTableRaw from './PropertyTableRaw';

interface Properties {
  propertyId: number;
  dimensionName: string;
  dimensionId: number;
  propertyName: string;
  planPermission: boolean;
  refetchRequest: () => void;
}

const PropertyTable = ({
  dimensionName,
  dimensionId,
  propertyName,
  planPermission,
  propertyId,
  refetchRequest,
}: Properties) => {
  const propertyValues: PropertyValue[] = useSelector(getPropertyValues);
  const dispatch: AppDispatch = useDispatch();
  const currentDriver = useSelector(getSelectedDriver);
  const baseScenario = useSelector(getBaseScenario);
  const scenarioId = baseScenario?.id;

  const onAddItem = async () => {
    await dispatch(
      addDimesionItem({
        dimension_id: dimensionId,
        request_body: addNewDimensionItem(propertyValues, scenarioId),
      }),
    );

    await dispatch(
      fetchPropertyValue({
        propertyId: currentDriver.property_id,
        parameters: { scenario_id: baseScenario?.id },
      }),
    );
  };

  return (
    <Box
      h='100%'
      overflowY='auto'
      overflowX='hidden'
      border='1px solid'
      borderColor={PLAN_TABLE_CELL_BORDER}
      borderRadius='8px'
    >
      <TableContainer>
        <Table variant='unstyled' size='sm' style={{ tableLayout: 'fixed', width: '100%' }}>
          <Thead position='sticky' top={0} zIndex={1}>
            <Tr>
              <Th
                bg={PLAN_TABLE_HEADER_BG}
                borderBottom='1px solid'
                borderColor={PLAN_TABLE_CELL_BORDER}
                py='10px'
                px='12px'
                textTransform='none'
              >
                <Tooltip label={dimensionName}>
                  <Text
                    {...PLAN_TEXT.tableHeader}
                    color={textToken.primary}
                    noOfLines={1}
                    display='block'
                  >
                    {dimensionName}
                  </Text>
                </Tooltip>
              </Th>
              <Th
                bg={PLAN_TABLE_HEADER_BG}
                borderBottom='1px solid'
                borderColor={PLAN_TABLE_CELL_BORDER}
                py='10px'
                px='12px'
                textTransform='none'
              >
                <Tooltip label={propertyName}>
                  <Text
                    {...PLAN_TEXT.tableHeader}
                    color={textToken.primary}
                    noOfLines={1}
                    display='block'
                  >
                    Enter {propertyName}
                  </Text>
                </Tooltip>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {propertyValues?.map((property: PropertyValue) => (
              <PropertyTableRaw
                key={`${property?.name}+${baseScenario?.name}`}
                property={property}
                propertyId={propertyId}
                refetchRequest={refetchRequest}
                planPermission={planPermission}
              />
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <Box
        py='10px'
        px='12px'
        borderTop='1px solid'
        borderColor={neutral.border}
        cursor={planPermission ? 'not-allowed' : 'pointer'}
      >
        <AddButton
          label={`Add ${dimensionName}`}
          onClick={planPermission ? undefined : onAddItem}
        />
      </Box>
    </Box>
  );
};

export default PlanPermission(PropertyTable);
